<template>
  <svg
    :width="width ? width : height ? height * (17 / 17) : 17"
    :height="height ? height : width ? width * (17 / 17) : 17"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M10.563 3.37c1.5835.5785 2.818 1.876 3.3035 3.4948h2.3097a.64.64 0 0 1 .64.64v1.641a.64.64 0 0 1-.64.64h-2.2683c-.4536 1.6863-1.7141 3.0447-3.3449 3.6405v2.3529a.64.64 0 0 1-.64.64H8.1397a.64.64 0 0 1-.64-.64v-2.161C5.5584 13.176 4.0172 11.69 3.505 9.7858H1.4562a.64.64 0 0 1-.64-.64v-1.641a.64.64 0 0 1 .64-.64h2.0903c.55-1.8341 2.0617-3.2559 3.9532-3.6867V1.2262a.64.64 0 0 1 .64-.64H9.923a.64.64 0 0 1 .64.64V3.37zm-1.8565 7.2937c1.258 0 2.2778-1.0143 2.2778-2.2656 0-1.2512-1.0198-2.2656-2.2778-2.2656S6.4286 7.147 6.4286 8.3981c0 1.2513 1.0199 2.2656 2.2779 2.2656z"
      :fill="iconColor"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'circle',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
